import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedVideos from './components/FeaturedVideos';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';

export default function Home() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': '蘑菇视频 - 高清在线视频聚合平台',
    'description': '蘑菇视频聚合西瓜视频免费、蜜桃视频等平台，提供高清电影电视剧免费在线观看，无广告流畅播放，VIP电影免费看，1080P画质。',
    'url': 'https://mogushipin.com',
    'isPartOf': {
      '@type': 'WebSite',
      'name': '蘑菇视频',
      'url': 'https://mogushipin.com',
    },
  };

  return (
    <>
      <SEOHead
        title="蘑菇视频 - 西瓜视频免费蜜桃视频高清在线观看 | 无广告流畅播放VIP电影免费1080P"
        description="蘑菇视频聚合西瓜视频免费、蜜桃视频等平台，提供高清电影电视剧免费在线观看，无广告流畅播放，VIP电影免费看，1080P画质。海量影视资源，每日更新。"
        keywords="蘑菇视频,西瓜视频免费,蜜桃视频,高清在线观看,无广告,流畅播放,VIP电影免费,1080P,免费看大片"
        canonicalUrl="https://mogushipin.com/"
        schema={schema}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedVideos />
        <ArticleList />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}